import type { InventoryListByIdAPI, InventoryListFormState } from '@openx/types/inventoryList';

const defaultInventoryList: InventoryListFormState = {
  name: '',
  description: '',
  account_uid: '',
  type_full: 'domains',
  values: [],
};

export const getInitialValues = (inventoryList: InventoryListByIdAPI | null): InventoryListFormState => {
  if (!inventoryList) {
    return defaultInventoryList;
  }

  const { name, account_uid, description, type_full, values } = inventoryList;
  const listType = type_full === 'inventorylist.bundle' ? 'bundles' : 'domains';

  return { ...defaultInventoryList, name, account_uid, description, type_full: listType, values };
};
